/**
 * Global Hex Exploration Service
 * 
 * Tracks which hexes have been explored by ANY player globally.
 * Used to identify unexplored hexes where new quests should always be generated.
 */

import { getFirestore, collection, doc, getDoc, setDoc, serverTimestamp } from 'firebase/firestore';
import app from '../firebase';
import { AxialCoord } from '../types/terrain';

const db = getFirestore(app);

export interface HexSponsorship {
  hexKey: string; // Format: "q,r"
  sponsoredQuestId: string; // Quest bound to this hex
  sponsoredBy: string; // User who sponsored
  sponsoredAt: any; // Firebase Timestamp
}

/**
 * Sponsor a quest to a specific hex
 */
export async function sponsorQuestToHex(
  hex: AxialCoord,
  questId: string,
  userId: string
): Promise<void> {
  try {
    const hexKey = `${hex.q},${hex.r}`;
    const hexRef = doc(db, 'sponsoredHexes', hexKey);
    
    await setDoc(hexRef, {
      hexKey,
      sponsoredQuestId: questId,
      sponsoredBy: userId,
      sponsoredAt: serverTimestamp(),
    });
    
    console.log(`🎯 Sponsored quest ${questId} to hex ${hexKey} by user ${userId}`);
    
  } catch (error) {
    console.error('Error sponsoring quest to hex:', error);
    throw error;
  }
}

/**
 * Get the sponsored quest for a specific hex (if any)
 */
export async function getSponsoredQuestForHex(hex: AxialCoord): Promise<string | null> {
  try {
    const hexKey = `${hex.q},${hex.r}`;
    const hexRef = doc(db, 'sponsoredHexes', hexKey);
    const hexDoc = await getDoc(hexRef);
    
    if (!hexDoc.exists()) {
      return null;
    }
    
    const data = hexDoc.data() as HexSponsorship;
    return data.sponsoredQuestId || null;
    
  } catch (error) {
    console.error('Error getting sponsored quest:', error);
    return null;
  }
}

